export const PLAID_CLIENT_FRAGMENT = process.env['REACT_APP_PLAID_CLIENT_FRAGMENT'];
export const PLAID_ENV = process.env['REACT_APP_PLAID_ENV'];
